module.exports = __webpack_public_path__ + "img/sdmines_logo.d6cdebe7.svg";